import { render, staticRenderFns } from "./BINCardWrapper.vue?vue&type=template&id=68401da6&lang=pug&"
import script from "./BINCardWrapper.vue?vue&type=script&lang=js&"
export * from "./BINCardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports